class WhenToContact {
  constructor(section) {
    this.section = section;

    this.init();
  }

  init() {
    if (!("IntersectionObserver" in window)) {
      this.reveal();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          this.reveal();
          observer.unobserve(this.section);
        });
      },
      {
        rootMargin: "0px 0px -30% 0px",
        threshold: 0.2,
      },
    );

    observer.observe(this.section);
  }

  reveal() {
    this.section.classList.add("is-visible");
  }
}

document.querySelectorAll(".when-to-contact").forEach((section) => {
  new WhenToContact(section);
});
